<div class="header-texts limit-width">
  <p class="mat-caption" i18n
    >Der Fragebogen wird zusammen mit dem Projekt abgegeben. Er muss für die Abgabe vollständig ausgefüllt werden.</p
  >

  <p class="mat-caption" i18n
    >Ein Fragebogen besteht aus mehreren Seiten, welche wiederum aus einzelnen Blöcken bestehen. Diese Blöcke können Fragen sein oder auch
    Textausgaben, die weitere Erklärungen liefern.</p
  >

  @if (event.questionnaireReleased) {
    <div class="info-box">
      <mat-icon>info</mat-icon>
      <ng-container i18n>Der Fragebogen ist bereits veröffentlicht und kann deshalb nicht mehr bearbeitet werden.</ng-container>
    </div>
  }
</div>

<div class="header-buttons-wrapper">
  <div class="header-buttons limit-width">
    <button mat-button (click)="preview()">
      <mat-icon>preview</mat-icon>
      <ng-container i18n>Vorschau</ng-container>
    </button>
    <button mat-button [disabled]="form.disabled" (click)="formService.addPage()">
      <mat-icon>add</mat-icon>
      <ng-container i18n>Seite hinzufügen</ng-container>
    </button>
    <button mat-button [disabled]="form.disabled || form.value.questionnaire.length < 2" (click)="reorder()">
      <mat-icon>reorder</mat-icon>
      <ng-container i18n>Seiten neu anordnen</ng-container>
    </button>
    <button mat-button (click)="collapseAll()">
      <mat-icon>unfold_less</mat-icon>
      <ng-container i18n>Alle einklappen</ng-container>
    </button>
    <button mat-button (click)="expandAll()">
      <mat-icon>unfold_more</mat-icon>
      <ng-container i18n>Alle ausklappen</ng-container>
    </button>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="save()" cdkDropListGroup class="limit-width">
  <ng-container formArrayName="questionnaire">
    @for (page of form.controls.questionnaire.controls; track page; let pageIndex = $index) {
      <ng-container [formArrayName]="pageIndex">
        <div class="questionnaire-page-header">
          <h2 i18n>Seite {{ pageIndex + 1 }}</h2>
          <button mat-button type="button" [disabled]="form.disabled" (click)="formService.deletePage(pageIndex)">
            <mat-icon>delete</mat-icon>
            <ng-container i18n>Seite löschen</ng-container>
          </button>
        </div>
        @if (page.controls.length === 0) {
          <mat-error class="dt-error empty-page-error" i18n>Seiten dürfen nicht leer sein</mat-error>
        }
        <div cdkDropList [cdkDropListData]="pageIndex" (cdkDropListDropped)="onDropEntry($event)">
          @for (entry of page.controls; track entry; let entryIndex = $index) {
            <div class="questionnaire-entry" cdkDrag [cdkDragData]="entryIndex" [cdkDragDisabled]="form.disabled">
              <dt-event-questionnaire-entry
                [formGroupName]="entryIndex"
                (delete)="formService.deleteEntry(pageIndex, entryIndex)"
                (changeEntryType)="formService.changeEntryType(pageIndex, entryIndex, $event)"
              ></dt-event-questionnaire-entry>
              @if (form.enabled) {
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div>
              }
            </div>
          }
        </div>
        <button mat-button type="button" [disabled]="form.disabled" (click)="formService.addEntry(pageIndex)">
          <mat-icon>add</mat-icon>
          <ng-container i18n>Block hinzufügen</ng-container>
        </button>
      </ng-container>
    }

    <div class="button-row">
      <button mat-raised-button color="primary" [disabled]="form.disabled" [dtOverlayProgress]="isSaving">
        <mat-icon>save</mat-icon>
        <ng-container i18n>Speichern</ng-container>
      </button>
      <button mat-raised-button type="button" [disabled]="form.disabled" (click)="save(true)">
        <mat-icon>publish</mat-icon>
        <ng-container i18n>Speichern und veröffentlichen</ng-container>
      </button>
      <button mat-raised-button type="button" [disabled]="form.disabled" (click)="reset()">
        <mat-icon>device_reset</mat-icon>
        <ng-container i18n>Zurücksetzen</ng-container>
      </button>
    </div>
  </ng-container>
</form>
